import { useSelector } from "react-redux";
import { FormControl, TextField, MenuItem } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { NONE } from "../../../consts/strings";

import { formatDateToCorrectTimeZone } from "../../../utils/date";

import { countriesSelector } from "../../../reducers/driverManagement/selectors";

import { View } from "../../View";

const useStyles = makeStyles(({ typography }) => ({
  form: {
    flexDirection: "column",
    alignItems: "center",
    gap: "1.5rem",
    padding: "1rem",
    minWidth: "48rem",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    width: "100%",
    gap: "1.5rem",
  },
  formLabel: {
    fontSize: "0.9rem",
  },
  formDropDown: {
    width: "200px",
  },
  formTextArea: { border: "none", width: "100%" },
}));

export const AppProfileModalContent = ({
  disabled,
  driverProfileEdit,
  onChange = async () => {},
  errors = {},
}) => {
  const styles = useStyles();
  const countries = useSelector(countriesSelector);

  const {
    namePronunciation,
    startDate,
    averageDeliveriesPerWeek,
    countryFlagCode,
    favouriteSong,
    biography,
    specialConsiderations,
  } = driverProfileEdit;

  const onProfileChange = async ({ target: { name, value } }) =>
    await onChange({ updates: [{ name, value }] });

  return (
    <FormControl className={styles.form} size="medium">
      <View className={styles.row}>
        <TextField
          variant="outlined"
          InputLabelProps={{ className: styles.formLabel, shrink: true }}
          label="Name Pronunciation"
          value={namePronunciation || ""}
          name="namePronunciation"
          onChange={onProfileChange}
          disabled={disabled}
        />
        <TextField
          variant="outlined"
          label="Start Date"
          type="date"
          value={startDate || ""}
          name="startDate"
          onChange={onProfileChange}
          InputProps={{
            inputProps: {
              max: formatDateToCorrectTimeZone(new Date()),
            },
          }}
          InputLabelProps={{
            className: styles.formLabel,
            shrink: true,
            readOnly: true,
          }}
          error={!!errors["startDate"]}
          helperText={errors["startDate"]}
          disabled={disabled}
        />
        <TextField
          variant="outlined"
          type="number"
          InputLabelProps={{ className: styles.formLabel, shrink: true }}
          label="Avg Deliveries Per Week"
          value={averageDeliveriesPerWeek || ""}
          name="averageDeliveriesPerWeek"
          onChange={onProfileChange}
          error={!!errors["averageDeliveriesPerWeek"]}
          helperText={errors["averageDeliveriesPerWeek"]}
          disabled={disabled}
        />
        <TextField
          variant="outlined"
          className={styles.formDropDown}
          select
          label="Country Flag"
          InputLabelProps={{ className: styles.formLabel, shrink: true }}
          value={countryFlagCode || NONE}
          defaultValue=""
          name="countryFlagCode"
          onChange={onProfileChange}
          disabled={disabled}
        >
          {[
            <MenuItem key={NONE} value={NONE}>
              {NONE}
            </MenuItem>,
            ...countries.map(({ countryCode, description }) => (
              <MenuItem
                key={`${countryCode}-${description}`}
                value={countryCode}
              >
                {countryCode}: {description}
              </MenuItem>
            )),
          ]}
        </TextField>
        <TextField
          variant="outlined"
          InputLabelProps={{ className: styles.formLabel, shrink: true }}
          label="Favourite Song"
          value={favouriteSong || ""}
          name="favouriteSong"
          onChange={onProfileChange}
          disabled={disabled}
        />
      </View>
      <View className={styles.row}>
        <TextField
          multiline
          minRows={3}
          maxRows={3}
          value={biography || ""}
          name="biography"
          onChange={onProfileChange}
          className={styles.formTextArea}
          InputLabelProps={{
            className: [styles.formLabel, styles.formTextAreaLabel],
            shrink: true,
          }}
          label="Biography"
          variant="outlined"
          disabled={disabled}
        />
        <TextField
          multiline
          minRows={3}
          maxRows={3}
          className={styles.formTextArea}
          value={specialConsiderations || ""}
          name="specialConsiderations"
          onChange={onProfileChange}
          InputLabelProps={{
            className: [styles.formLabel, styles.formTextAreaLabel],
            shrink: true,
          }}
          label="Special Considerations"
          variant="outlined"
          disabled={disabled}
        />
      </View>
    </FormControl>
  );
};
